import { Routes } from "@angular/router";

export const CAPTURISTA_ROUTES: Routes = [
  { path: '', redirectTo: 'capturista', pathMatch: 'full' },
  { path: 'capturista', loadChildren: './pages/capturista/capturista.module#CapturistaModule' }
];